var React = require('react');

function ContentFiltering (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 4.75C20.0962 4.75 23.778 5.19382 26.4131 5.89648C27.7359 6.24923 28.7527 6.65597 29.4209 7.07715C30.1266 7.52206 30.25 7.853 30.25 8C30.25 8.147 30.1266 8.47794 29.4209 8.92285C28.7527 9.34403 27.7359 9.75077 26.4131 10.1035C23.778 10.8062 20.0962 11.25 16 11.25C11.9038 11.25 8.222 10.8062 5.58691 10.1035C4.26412 9.75077 3.24727 9.34403 2.5791 8.92285C1.87342 8.47794 1.75 8.147 1.75 8C1.75 7.853 1.87342 7.52206 2.5791 7.07715C3.24727 6.65597 4.26412 6.24923 5.58691 5.89648C8.222 5.19382 11.9038 4.75 16 4.75Z","stroke":"white","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M2 8.5L13.2 19.2088V28L18.8 25.6071V19.2088L30 8.5","stroke":"white","strokeWidth":"1.5","key":1})]);
}

ContentFiltering.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ContentFiltering;

ContentFiltering.default = ContentFiltering;
